import styled, { css } from 'styled-components'

export const Wrapper = styled.div<{ $isEmpty: boolean }>`
  ${(props) =>
    props.$isEmpty
      ? css`
          .ant-select-selection {
            height: 40px;
            .ant-select-selection__rendered {
              height: 100%;
            }
          }
        `
      : css`
          .ant-select-selection {
            height: 50px;
            .ant-select-selection__rendered {
              height: 100%;
            }
          }
          .ant-select-selection-selected-value {
            > div {
              margin-top: 4px;
              margin-bottom: 4px;
            }
          }
        `}
`

export const Subtitle = styled.div`
  color: #757575;
  font-size: 14px;
  font-weight: 700;
  padding-bottom: 4px;
`

export const OptionWrapper = styled.div`
  margin-top: -7px;
  margin-bottom: -7px;
  small {
    font-size: 12px !important;
    line-height: 1.2;
  }
`
